// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_8t-0";
export var optionCard = "_8t-1";